import React from 'react';
import QuerySampleCard from '../components/QuerySampleCard';
import QueryHelpPageLayout from '../QueryHelpPageLayout';
import {QUERY_HELP_PAGE_INTROS} from '../content/pages';
import {QUERY_SAMPLE_GROUPS} from '../content/querySamples';

const QuerySamplesPage = React.memo(() => (
    <QueryHelpPageLayout
        title="Query samples"
        intro={QUERY_HELP_PAGE_INTROS.samples}
    >
        {QUERY_SAMPLE_GROUPS.map((group) => (
            <section key={group.id} className="query-help-modal__sample-group">
                <h4 className="query-help-modal__section-title">{group.title}</h4>
                <div className="query-help-modal__sample-list">
                    {group.items.map((item) => (
                        <QuerySampleCard key={item.id} item={item} />
                    ))}
                </div>
            </section>
        ))}
    </QueryHelpPageLayout>
));

export default QuerySamplesPage;
